import { Skeleton } from '@sea-snag/ui';
import { Navigate, useLocation } from '@tanstack/react-router';

import { useUser } from '../hooks/use-auth';
import { pickInitialOrg } from '../stores/org-store';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

export function SuperAdminRoute({ children }: SuperAdminRouteProps) {
  const { user, isLoading, isAuthenticated } = useUser();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="w-full max-w-md space-y-4 p-4">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" search={{ redirect: location.pathname }} />;
  }

  if (!user?.isSuperAdmin) {
    const orgs = (user?.organizations ?? []).map((o) => ({
      pid: o.id,
      name: o.name,
      slug: o.slug,
      setupCompletedAt: o.setupCompletedAt,
    }));
    const org = pickInitialOrg(orgs);
    if (org) {
      return <Navigate to="/$orgPid/dashboard" params={{ orgPid: org.pid }} />;
    }
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
}
